import React, { useState } from 'react';
import {
    Box,
    Button,
    Card, CardContent,
    CardHeader,
    Divider,
    TextField
} from '@material-ui/core';
import { useApi } from '../../components/api';


export const InvitationForm = ({ className, ...rest }: any) => {

    const isLoading = false;
    const errorMessage = undefined;

    const { api } = useApi();

    const [inviteId, setInviteId] = useState<string | undefined>(undefined);

    const handleSubmit = async (ev: any) => {
        ev.preventDefault();
        const { email, codeRef } = ev.currentTarget.elements;

        const target = { email: email.value, refCode: codeRef.value };

        const resp = await api.post<{ inviteId?: string; }>('tenant/invite/client', target);

        setInviteId(resp.data.inviteId);
    };

    return (
        <form
            noValidate
            onSubmit={handleSubmit}
        >
            <Card>
                <CardHeader
                    subheader="Gera um código de convite a ser entregue para o cliente, possibilitando assim o mesmo acessar os dados via portal do cliente"
                    title="Convidar cliente" />
                <Divider />
                <CardContent>

                    <i className="small">Atenção: Após se cadastrar o usuário do email informado terá acesso as informações geradas pelo sistemas Softplus pertencentes ao cliente informado no 'código do sistema'. Certifique-se de utilizar o codigo correto.</i>

                    <TextField
                        fullWidth
                        label="Email"
                        margin="normal"
                        name="email"
                        type="email"
                        variant="outlined" />

                    <TextField
                        fullWidth
                        label="Codigo no sistema"
                        margin="normal"
                        name="codeRef"
                        type="text"
                        variant="outlined" />

                </CardContent>
                <Divider />
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    p={2}
                >
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isLoading}
                    >
                        Criar convite
                    </Button>

                </Box>
                {errorMessage && <p>{errorMessage}</p>}

                {inviteId && <div>
                    <p>Convite criado! Peça para o usuario se cadastrar com o email informado e utilizar o seguinte código quando solicitado:</p>
                    <p>{inviteId}</p>
                </div>}
            </Card>
        </form>
    );
};
